import { ArrowUp, ArrowDown, ArrowUpDown } from "lucide-react";
import { cn } from "@/lib/utils";
import type { SortDirection } from "@/hooks/useTableSort";

interface SortableHeaderProps {
  label: string;
  sortKey: string;
  currentKey: string | null;
  currentDirection: SortDirection;
  onToggle: (key: string) => void;
  className?: string;
}

export function SortableHeader({
  label,
  sortKey,
  currentKey,
  currentDirection,
  onToggle,
  className,
}: SortableHeaderProps) {
  const isActive = currentKey === sortKey;

  return (
    <button
      type="button"
      className={cn(
        "inline-flex items-center gap-1 text-left font-medium text-muted-foreground hover:text-foreground transition-colors select-none group",
        isActive && "text-foreground",
        className,
      )}
      onClick={() => onToggle(sortKey)}
    >
      {label}
      <span className={cn(
        "transition-opacity",
        isActive ? "opacity-100" : "opacity-0 group-hover:opacity-50",
      )}>
        {isActive && currentDirection === "asc" ? (
          <ArrowUp className="h-3.5 w-3.5" />
        ) : isActive && currentDirection === "desc" ? (
          <ArrowDown className="h-3.5 w-3.5" />
        ) : (
          <ArrowUpDown className="h-3.5 w-3.5" />
        )}
      </span>
    </button>
  );
}
